import api from '../../../App/socket';

export const addNote = (_id, note) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'NestedCreate',
        options: {
            fullPath: 'notes',
            where: { _id },
            create: { note },
        },
    }).then((response) => response).catch((error) => error)
);

export const delNote = (leadId, noteId) => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'deleteLeadNote',
    options: {
        leadId,
        noteId,
    },
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/add_note_request.js